import React, { useState, Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Users, Anchor, Share2, RefreshCw } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
import { openProspectusModal } from '../components/ProspectusModal';
import { openTeamBioModal } from '../components/TeamBioModal';
import { PhotoCredit } from '../components/PhotoCredit';
export function HomePage() {
  const [heroVariant, setHeroVariant] = useState<'overlay' | 'split'>('split');
  return <div data-id="element-478">
      {heroVariant === 'overlay' /* Hero A — Centered Text with Duotone Background */ ? <section className="relative py-14 md:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-479">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/8SSxfoLnV85LCJMD3vD2xt/Final_-_Firetree_Prospectus.png")'
      }} data-id="element-480" />
          <div className="absolute inset-0 mix-blend-multiply" style={{
        backgroundColor: 'rgba(174, 38, 36, 0.7)'
      }} data-id="element-481" />
          <div className="absolute inset-0" style={{
        backgroundColor: 'rgba(174, 38, 36, 0.5)'
      }} data-id="element-482" />

          <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-483">
            <AnimatedSection data-id="element-484">
              <p className="text-[14px] text-white/90 mb-6 leading-relaxed" style={{
            fontFamily: 'Manrope, sans-serif'
          }} data-id="element-485">
                Finding impactful organisations is hard. Knowing the ones with
                solid leadership, processes and governance, is harder still.
              </p>
            </AnimatedSection>
            <AnimatedSection delayClass="delay-200" data-id="element-486">
              <h1 className="text-[23px] md:text-[29px] lg:text-[41px] font-serif text-white leading-tight mb-6" data-id="element-487">
                Firetree offers funders curated access to established, highly
                effective local organizations with proven models in Southeast
                Asia.
              </h1>
            </AnimatedSection>
            <AnimatedSection delayClass="delay-300" data-id="element-488">
              <p className="text-[14px] text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto" style={{
            fontFamily: 'Manrope, sans-serif'
          }} data-id="element-489">
                Each organisation in this portfolio has been selected by members
                of the Firetree team who have created, run and backed
                organisations themselves.
              </p>
            </AnimatedSection>
            <AnimatedSection delayClass="delay-400" data-id="element-490">
              <div className="flex justify-center" data-id="element-491">
                <button onClick={openProspectusModal} className="inline-flex items-center justify-center px-8 py-3.5 bg-white text-brand-red font-semibold hover:bg-brand-charcoal hover:text-white transition-all duration-300" data-id="element-492">
                  Download prospectus
                </button>
              </div>
            </AnimatedSection>
          </div>

          <div className="absolute bottom-0 right-0 p-2 pr-3 pointer-events-none z-10" data-id="element-493">
            <span className="text-[10px] text-white font-medium opacity-80 drop-shadow-sm" data-id="element-494">
              Photo: M'Lop Tapang
            </span>
          </div>
        </section> /* Hero B — Text / Image Split */ : <section className="relative grid grid-cols-1 lg:grid-cols-2 min-h-[70vh]" data-id="element-495">
          {/* Text Side */}
          <div className="flex flex-col justify-center py-14 md:py-20 lg:py-24" style={{
        backgroundColor: '#ae2624'
      }} data-id="element-496">
            <div className="w-full max-w-[640px] mx-auto lg:ml-auto lg:mr-0 px-4 sm:px-6 lg:px-16 lg:pr-12 text-center lg:text-left" data-id="element-497">
              <AnimatedSection data-id="element-498">
                <p className="text-[15px] text-white/80 mb-5 leading-relaxed max-w-md mx-auto lg:mx-0" style={{
              fontFamily: 'Manrope, sans-serif'
            }} data-id="element-499">
                  Finding impactful organisations is hard. Knowing the ones with
                  solid leadership, processes and governance, is harder still
                </p>
              </AnimatedSection>
              <AnimatedSection delayClass="delay-200" data-id="element-500">
                <h1 className="text-[21px] md:text-[24px] lg:text-[32px] font-serif text-white leading-tight mb-5" data-id="element-501">
                  Firetree offers funders curated access to established, highly
                  effective local organizations with proven models in Southeast
                  Asia
                </h1>
              </AnimatedSection>
              <AnimatedSection delayClass="delay-300" data-id="element-502">
                <p className="text-[15px] text-white/80 mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0" style={{
              fontFamily: 'Manrope, sans-serif'
            }} data-id="element-503">
                  Each organisation in this portfolio has been selected by
                  members of the Firetree team who have created, run and backed
                  organisations themselves
                </p>
              </AnimatedSection>
              <AnimatedSection delayClass="delay-400" data-id="element-504">
                <div className="flex justify-center lg:justify-start" data-id="element-505">
                  <button onClick={openProspectusModal} className="inline-flex items-center justify-center px-8 py-3.5 bg-white font-semibold border-2 border-white hover:bg-transparent hover:text-white transition-colors duration-300" style={{
                color: undefined
              }}
              // Default state: white bg, red text. Hover: transparent bg, white text, white border
              ref={el => {
                if (el) {
                  el.style.color = '#ae2624';
                  el.addEventListener('mouseenter', () => {
                    el.style.color = 'white';
                  });
                  el.addEventListener('mouseleave', () => {
                    el.style.color = '#ae2624';
                  });
                }
              }} data-id="element-506">
                    Download prospectus
                  </button>
                </div>
              </AnimatedSection>
            </div>
          </div>

          {/* Image Side */}
          <PhotoCredit credit="Photo: M'Lop Tapang" className="relative min-h-[300px] lg:min-h-0" data-id="element-507">
            <img src="https://cdn.magicpatterns.com/uploads/8SSxfoLnV85LCJMD3vD2xt/Final_-_Firetree_Prospectus.png" alt="Children in Southeast Asia" className="absolute inset-0 w-full h-full object-cover" data-id="element-508" />
          </PhotoCredit>
        </section>}
      {/* Who Runs the Fund */}
      <section className="text-white py-16" style={{
      backgroundColor: '#243462'
    }} data-id="element-509">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-510">
          <AnimatedSection data-id="element-511">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-512">
              Who runs the Fund
            </h2>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-200" data-id="element-513">
            <p className="text-lg md:text-xl text-white/80 mb-8 leading-relaxed" data-id="element-514">
              The Firetree Fund was conceptualised and is governed by{' '}
              <button onClick={() => openTeamBioModal('francesco')} className="text-white underline underline-offset-2 decoration-white/40 hover:decoration-white transition-colors cursor-pointer" data-id="element-515">
                Francesco Caruso
              </button>
              . The portfolio is managed by{' '}
              <button onClick={() => openTeamBioModal('sreya')} className="text-white underline underline-offset-2 decoration-white/40 hover:decoration-white transition-colors cursor-pointer" data-id="element-516">
                Sreya Bhattacharya
              </button>
              , and advised by a regional panel of technical experts chaired by{' '}
              <button onClick={() => openTeamBioModal('nicky')} className="text-white underline underline-offset-2 decoration-white/40 hover:decoration-white transition-colors cursor-pointer" data-id="element-517">
                Nicky Wilkinson
              </button>
              . The panel brings decades of direct experience across child
              protection, education and nonprofit leadership in Southeast Asia.
            </p>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-400" data-id="element-518">
            <a href="https://firetree.org/team" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 border font-semibold transition-all duration-300 group" style={{
            color: '#aacafe',
            borderColor: '#aacafe'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#aacafe';
            e.currentTarget.style.color = '#243462';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#aacafe';
          }} data-id="element-519">
              Meet the Entire Firetree Team
              <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform -rotate-45" data-id="element-520" />
            </a>
          </AnimatedSection>
        </div>
      </section>

      {/* Image Breaker */}
      <AnimatedSection data-id="element-521">
        <div className="relative h-64 md:h-[28rem] w-full overflow-hidden" data-id="element-522">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform hover:scale-105 transition-transform duration-1000" style={{
          backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/s83c2u5n4dwteNUcPVpfeY/41EB71B4-3B75-41FD-A6DF-F80809827273.jpg")'
        }} data-id="element-523" />
          <div className="absolute inset-0 bg-brand-charcoal/20 mix-blend-multiply" data-id="element-524" />
          <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" data-id="element-525" />
          <div className="absolute bottom-0 right-0 p-2 pr-3 pointer-events-none" data-id="element-526">
            <span className="text-[10px] text-white font-medium opacity-80 drop-shadow-sm" data-id="element-527">
              © Firetree Fund
            </span>
          </div>
        </div>
      </AnimatedSection>

      {/* How We Work Summary */}
      <section className="bg-brand-card/30 py-16" data-id="element-528">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-529">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-end mb-12" data-id="element-530">
            <AnimatedSection data-id="element-531">
              <div data-id="element-532">
                <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-533">
                  Our expertise
                </h2>
                <p className="text-lg md:text-xl text-brand-brown" data-id="element-534">
                  We have built our expertise over 20 years of working with
                  organisations, within organisations to understand the regions,
                  issues and communities that we work in.
                </p>
              </div>
            </AnimatedSection>
            <AnimatedSection delayClass="delay-200" data-id="element-535">
              <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-4 lg:items-end lg:justify-end" data-id="element-536">
                <Link to="/how-we-work" className="inline-flex items-center px-6 py-3 border border-brand-red text-brand-red font-semibold hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-537">
                  Our Approach
                  <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-538" />
                </Link>
              </div>
            </AnimatedSection>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-539">
            <AnimatedSection delayClass="delay-100" data-id="element-540">
              <div className="bg-brand-cream p-8 md:p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-541">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-542">
                  <Building2 className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-543" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-544">
                  We operate, not just fund
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-545">
                  We fully fund and operate TCI in Manila and Starfish Education
                  Foundation in Thailand.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-200" data-id="element-546">
              <div className="bg-brand-cream p-8 md:p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-547">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-548">
                  <Users className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-549" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-550">
                  We've been in the room
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-551">
                  We have lived through the day-to-day challenges of the
                  transitions. With Board experience across 20+ organisations,
                  we know what great governance and decision-making under
                  pressure really like.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-300" data-id="element-552">
              <div className="bg-brand-cream p-8 md:p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-553">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-554">
                  <Anchor className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-555" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-556">
                  We are in it for the long run
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-557">
                  We know that trust, value, unrestricted funding, partnerships,
                  give leaders the time and space to focus on the impact of the
                  organisation.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-400" data-id="element-558">
              <div className="bg-brand-cream p-8 md:p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-559">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-560">
                  <Share2 className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-561" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-562">
                  We talk about who we fund
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-563">
                  Every organisation in this portfolio is one we currently fund
                  ourselves, and intend to continue funding. This is not a way
                  to wind down but rather to double down.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Who We Work With — 2 Column: Content Left, Image Right */}
      <section className="overflow-hidden" data-id="element-564">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch" data-id="element-565">
          {/* Left column — Text + Logos */}
          <div className="flex flex-col justify-center py-16 px-6 sm:px-10 lg:px-16 xl:pl-[max(2rem,calc((100vw-80rem)/2+2rem))]" data-id="element-566">
            <AnimatedSection data-id="element-567">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-568">
                Who we work with
              </h2>
              <p className="text-lg text-brand-brown mb-8 leading-relaxed" data-id="element-569">
                We partner with established, high-capacity organisations across
                Southeast Asia. Each has been selected through years of direct
                engagement and operational partnership.
              </p>
              <Link to="/who-we-fund" className="inline-flex items-center px-6 py-3 border border-brand-red text-brand-red font-semibold hover:bg-brand-red hover:text-white transition-all duration-300 group mb-12" data-id="element-570">
                Discover our portfolio
                <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-571" />
              </Link>
            </AnimatedSection>

            {/* Logo Grid */}
            <AnimatedSection delayClass="delay-200" data-id="element-572">
              <div className="flex flex-wrap justify-center gap-6 md:gap-8 items-center" data-id="element-573">
                <img src="https://cdn.magicpatterns.com/uploads/hBKFw5Z4VmXDFzi7HBerWe/Clip_path_group-1.png" alt="Teach for the Philippines" className="h-12 md:h-14 object-contain" style={{
                flexBasis: 'calc(25% - 1.5rem)'
              }} data-id="element-574" />
                <img src="https://cdn.magicpatterns.com/uploads/vekhDhrMTRHY8ecHtfFeYM/Capture_edited.png" alt="Stairway Foundation" className="h-8 md:h-10 object-contain" style={{
                flexBasis: 'calc(25% - 1.5rem)'
              }} data-id="element-575" />
                <img src="https://cdn.magicpatterns.com/uploads/kccRsmJbEXxPheXu7TEfAC/Clip_path_group-3.png" alt="Yayasan Chow Kit" className="h-12 md:h-14 object-contain" style={{
                flexBasis: 'calc(25% - 1.5rem)'
              }} data-id="element-576" />
                <img src="https://cdn.magicpatterns.com/uploads/9t4qxiTE8YKLF7aBfRCmCg/Mith-Samlanh-Logo.png" alt="Mith Samlanh" className="h-12 md:h-14 object-contain" style={{
                flexBasis: 'calc(25% - 1.5rem)'
              }} data-id="element-577" />
                <img src="https://cdn.magicpatterns.com/uploads/nuaodW4ZMkGrvMHkQXTPx7/Clip_path_group-5.png" alt="Baan Dek Foundation" className="h-12 md:h-14 object-contain" style={{
                flexBasis: 'calc(25% - 1.5rem)'
              }} data-id="element-578" />
                <img src="https://cdn.magicpatterns.com/uploads/ifMd4jTfKdYrTvVogSeHHE/pasted-image.webp" alt="M'Lop Tapang" className="h-12 md:h-14 object-contain" style={{
                flexBasis: 'calc(25% - 1.5rem)'
              }} data-id="element-579" />
                <img src="https://cdn.magicpatterns.com/uploads/6X3g4qmNLkUKZ88YzN3UNU/435005263_823456339614584_4947231512097066411_n.png" alt="Peuan Peuan" className="h-12 md:h-14 object-contain" style={{
                flexBasis: 'calc(25% - 1.5rem)'
              }} data-id="element-580" />
              </div>
            </AnimatedSection>

            {/* Quote */}
            <AnimatedSection delayClass="delay-300" data-id="element-581">
              <p className="text-sm text-brand-brown leading-relaxed font-medium mt-10" data-id="element-582">
                This is the offer the Firetree Fund makes: not a directory, but
                curated access to organisations tested through real partnership
                and assessed by people who are practitioners and funders
                themselves.
              </p>
            </AnimatedSection>
          </div>

          {/* Right column — Image */}
          <PhotoCredit credit="Photo: M'Lop Tapang" className="relative min-h-[300px] lg:min-h-[500px]" data-id="element-583">
            <img src="https://cdn.magicpatterns.com/uploads/sHeYWZn3UV7SRjz1fYD2X3/Mlop_Tapang_4.png" alt="M'Lop Tapang community outreach" className="absolute inset-0 w-full h-full object-cover" data-id="element-584" />
          </PhotoCredit>
        </div>
      </section>
    </div>;
}